import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import App from "./App";

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:packageType" element={<App />} />
        <Route path="/" element={<App />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
